<script setup>
/* eslint-disable */
import NavUser from './components/navUser.vue';
import NavCarShop from './components/navCartShop.vue';
import NavSearch from './components/navSearch.vue';
import NavbarDesktop from './navbarDesktop/navbarDesktop.vue';
import NavbarMobile from './navbarMobile/navbarMobile.vue';
import feather from 'feather-icons'
import { onMounted, onUnmounted, ref } from 'vue'

const account = ref(false)
const activeMenu = ref('')

onMounted(() => {
  feather.replace()

  window.addEventListener('scroll', handleScroll)
  activeMenu.value = window.location.pathname
  
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    
})

const handleScroll = () => {
  const navbar = document.getElementById('topnav')
  if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
    navbar.classList.add('nav-sticky')
  } else {
    navbar.classList.remove('nav-sticky')
  }
}

// Función para cerrar los menús
const close = (e) => {
  if (!e.target.closest('#topnav')) {
    account.value = false
  }
}
</script>
<template>
  <div class="flex flex-col">
    <!-- Start Navbar -->
    <nav id="topnav" class="is-sticky">
      <div class="container relative flex justify-between items-center my-4">
        <router-link to="/" class="logo">
          <div>
            <img
              src="../../assets/images/logo_casa_campana.webp"
              class="h-[50px] lg:h-[60px] 2xl:h-[70px] inline-block dark:brightness-0 dark:invert"
              alt=""
            />
          </div>
        </router-link>
        <NavbarDesktop />
        <div class="flex gap-1">
          <NavSearch class="hidden xl:block" />
          <NavCarShop />
          <NavUser />
          <NavbarMobile />
        </div>
      </div>
      <div class="container flex xl:hidden py-4 w-full">
        <NavSearch />
      </div>
    </nav>
    <!--end header-->
    <!-- End Navbar -->
  </div>
</template>
<style lang="scss" scoped></style>
